// ============================================================================
// JAPANESE TRANSLATIONS - CHAPTER 6: パウロの宣教旅行
// ============================================================================
// レベル 66-78（13レベル、39問題）

export const chapter6Translations = {
  name: "パウロの宣教旅行",
  description: "地の果てまで...",
  
  spiritualWisdom: {
    principle: "福音はすべての国民のためであり、全世界に宣べ伝えられなければならない",
    scripture: "行って、あらゆる国の人々を弟子としなさい（マタイ28:19）",
    application: "すべてのクリスチャンは、神が置かれた場所でキリストの証人となるよう召されている"
  },
  
  levels: {
    66: {
      name: "第一次宣教旅行",
      challenge: "バルナバとサウロを私のために聖別しなさい。彼らを召した働きのために...",
      easy: {
        question: "パウロの最初の旅に誰が同行しましたか？",
        options: ["ペテロ", "バルナバ", "シラス", "テモテ"],
        hint: "'慰めの子'",
        funFact: "👥 バルナバはパウロの回心後、彼を受け入れた - 摂理的なパートナーシップ！"
      },
      medium: {
        question: "彼らはどの都市から宣教に出発しましたか？",
        options: [
          "エルサレム",
          "シリアのアンティオキア",
          "タルソ",
          "ダマスコ"
        ],
        hint: "ユダヤ人と異邦人の混合教会の最初",
        funFact: "🚢 アンティオキア：西洋世界の福音化の出発港！"
      },
      hard: {
        question: "この最初の旅は宣教戦略について何を明らかにしていますか？",
        options: [
          "自分の地域に留まるべき",
          "福音はすべての文化的境界を超える",
          "ユダヤ人だけが救われることができる",
          "宣教は任意である"
        ],
        hint: "メッセージの普遍性に関するもの",
        funFact: "🌊 地中海を渡る = 世界的な福音化への一歩！"
      }
    },
    
    67: {
      name: "キプロスでエリマと",
      challenge: "あらゆる偽りと悪巧みに満ちた者、悪魔の子よ...",
      easy: {
        question: "キプロスでパウロに反対した魔術師は誰ですか？",
        options: ["シモン", "エリマ", "アポロ", "アレクサンデル"],
        hint: "総督を背かせようとした偽預言者",
        funFact: "🪄 福音と魔術の最初の直接対決！"
      },
      medium: {
        question: "パウロはエリマに罰として何をしましたか？",
        options: [
          "彼を追い出した",
          "彼を一時的に盲目にした",
          "彼を無視した",
          "彼と議論した"
        ],
        hint: "霊的な目を開くための一時的な盲目",
        funFact: "👁️ 神の皮肉：魂を盲目にしていた者が一時的に盲目になる！"
      },
      hard: {
        question: "このエピソードは福音の力をどのように示していますか？",
        options: [
          "暴力が必要",
          "神の真理が偽りに勝利する",
          "すべての魔術師と戦わなければならない",
          "パウロは復讐心が強かった"
        ],
        hint: "欺瞞に対する神の権威に関するもの",
        funFact: "⚡ 総督は神の力を見て信じた - 効果的な証し！"
      }
    },

    68: {
      name: "ピシデヤのアンティオキアで",
      challenge: "神の言葉は、まずあなたがたに語られるべきでした...",
      easy: {
        question: "パウロは都市に到着すると、まずどこで説教しましたか？",
        options: [
          "公共の広場で",
          "まず会堂で",
          "金持ちの家で",
          "異教の神殿で"
        ],
        hint: "彼は常に自分の民から始めた",
        funFact: "🕍 宣教戦略：まずユダヤ人に、次に異邦人に！"
      },
      medium: {
        question: "ユダヤ人はパウロのメッセージにどのように反応しましたか？",
        options: [
          "全員が受け入れた",
          "分裂した：ある者は信じ、ある者は反対した",
          "無関心のままだった",
          "すぐに彼を追い出した"
        ],
        hint: "福音に対する典型的な分裂",
        funFact: "⚖️ 福音は常に分裂させる：受け入れるか拒絶するか、無関心はない！"
      },
      hard: {
        question: "なぜパウロは異邦人に向かうのですか？",
        options: [
          "彼は異邦人を好んだ",
          "ユダヤ人の拒絶が異邦人への扉を開く",
          "それが簡単だった",
          "彼は使命を放棄した"
        ],
        hint: "預言の成就に関するもの",
        funFact: "🚪 '異邦人の光' - イザヤの預言がパウロによって成就！"
      }
    },

    69: {
      name: "ルステラでの癒し",
      challenge: "神々が人間の姿をとって、私たちのところに下って来られた！",
      easy: {
        question: "パウロはルステラで何を癒しましたか？",
        options: [
          "盲人",
          "生まれつきの足の不自由な人",
          "聾唖者",
          "らい病人"
        ],
        hint: "一度も歩いたことのない人",
        funFact: "🦵 驚くべき奇跡：'自分の足でまっすぐに立ちなさい！' - 癒しの信仰！"
      },
      medium: {
        question: "群衆はパウロとバルナバを誰だと思いましたか？",
        options: [
          "王たち",
          "神々（ゼウスとヘルメス）",
          "魔術師",
          "預言者"
        ],
        hint: "ギリシャ神話の神々",
        funFact: "⚡ バルナバ = ゼウス（威厳のある）、パウロ = ヘルメス（雄弁家）- 文化的誤解！"
      },
      hard: {
        question: "パウロはこの偶像崇拝にどのように反応しましたか？",
        options: [
          "栄誉を受け入れる",
          "衣を引き裂いて真の神を説く",
          "礼儀正しく沈黙する",
          "状況を利用する"
        ],
        hint: "偶像崇拝の完全な拒絶",
        funFact: "👔 衣を引き裂く = 偶像崇拝に対するユダヤ人の恐怖 - 完全な誠実さ！"
      }
    },

    70: {
      name: "石打ちと復活",
      challenge: "弟子たちが彼を取り囲んでいると、彼は立ち上がって町に入って行った...",
      easy: {
        question: "ルステラの住民はパウロに何をしましたか？",
        options: [
          "投獄した",
          "石打ちにした",
          "追放した",
          "十字架につけた"
        ],
        hint: "伝統的なユダヤの刑罰",
        funFact: "🪨 一日で'神'から'死者'へ - 人間の群衆の移り気！"
      },
      medium: {
        question: "パウロは石打ちにされた後、何をしましたか？",
        options: [
          "町から逃げた",
          "隠れた",
          "立ち上がって町に戻った",
          "病院に行った"
        ],
        hint: "死んだと思われた後の超自然的な勇気",
        funFact: "💪 奇跡的な復活または神の癒し - 信じられない勇気！"
      },
      hard: {
        question: "この迫害は証しの代価について何を明らかにしていますか？",
        options: [
          "争いを避けなければならない",
          "キリストのために証しすることは命を犠牲にする可能性がある",
          "パウロは軽率だった",
          "迫害は無駄である"
        ],
        hint: "真実の証しの代価に関するもの",
        funFact: "✝️ '多くの苦難を経て神の国に入らなければならない' - パウロの現実主義！"
      }
    },

    71: {
      name: "エルサレム会議",
      challenge: "割礼を受けなければ、救われることはできません...",
      easy: {
        question: "エルサレム会議でどのような重要な議論が行われましたか？",
        options: [
          "バプテスマ",
          "改宗した異邦人の割礼",
          "安息日",
          "献金"
        ],
        hint: "クリスチャンになるためにユダヤ人にならなければならないか？",
        funFact: "✂️ 最初の大きな危機：キリスト教かユダヤ・キリスト教か？"
      },
      medium: {
        question: "会議の最終決定は何でしたか？",
        options: [
          "割礼は義務",
          "異邦人には自由、いくつかの勧告あり",
          "ユダヤ人からの完全な分離",
          "決定の延期"
        ],
        hint: "大きな制限なしに異邦人への開放",
        funFact: "🆓 歴史的革命：福音はモーセの律法から自由！"
      },
      hard: {
        question: "この会議は普遍的教会にとってどのような重要性がありますか？",
        options: [
          "些細な出来事",
          "信仰のみによる救いの普遍性を確立する",
          "教会を分裂させる",
          "律法主義を強化する"
        ],
        hint: "普遍的教会の基礎に関するもの",
        funFact: "🌍 この決定がなければ、キリスト教はユダヤ教の一派に留まっていたかもしれない！"
      }
    },

    72: {
      name: "第二次旅行：テモテ",
      challenge: "パウロは彼を連れて行きたいと思い、ユダヤ人のために彼に割礼を施した...",
      easy: {
        question: "誰が若い協力者としてパウロに加わりましたか？",
        options: ["マルコ", "ルカ", "テモテ", "テトス"],
        hint: "パウロの'愛する息子'",
        funFact: "👦 テモテ：若い神童がパウロの右腕に - 成功した弟子訓練！"
      },
      medium: {
        question: "獲得した自由にもかかわらず、なぜパウロはテモテに割礼を施したのですか？",
        options: [
          "法的義務による",
          "ユダヤ人の中での宣教戦略による",
          "伝統による",
          "誤りによる"
        ],
        hint: "障害を避けるための実践的な知恵",
        funFact: "🎯 知恵のある自由：'すべての人に対してすべてのものとなった。何とかして幾人かでも救うため'！"
      },
      hard: {
        question: "この態度は宣教の柔軟性をどのように示していますか？",
        options: [
          "パウロは一貫性がなかった",
          "彼は福音を妥協することなく方法を適応させた",
          "彼は圧力に屈した",
          "彼は偽善的だった"
        ],
        hint: "文脈的な知恵に関するもの",
        funFact: "⚖️ 確固たる原則、柔軟な方法 - 効果的な証しの技術！"
      }
    },

    73: {
      name: "マケドニア人の幻",
      challenge: "マケドニアに渡って来て、私たちを助けてください！",
      easy: {
        question: "パウロは夜の幻で何を見ましたか？",
        options: [
          "天使",
          "マケドニア人が彼を呼んでいる",
          "イエスが彼に語りかけている",
          "大きな光"
        ],
        hint: "ヨーロッパからの助けの叫び",
        funFact: "🌉 決定的な幻：福音がヨーロッパに渡る - 歴史的転換点！"
      },
      medium: {
        question: "最初に福音化されたヨーロッパの都市はどこですか？",
        options: [
          "アテネ",
          "コリント",
          "ピリピ",
          "テサロニケ"
        ],
        hint: "マケドニアのローマ植民地",
        funFact: "🏛️ ピリピ：最初のヨーロッパ教会 - 大陸が永遠に変えられた！"
      },
      hard: {
        question: "この幻はキリスト教の歴史にとって何を象徴していますか？",
        options: [
          "普通の夢",
          "西方への摂理的拡大",
          "幻覚",
          "計画の変更"
        ],
        hint: "歴史を導く摂理に関するもの",
        funFact: "🗺️ この幻がなければ、ヨーロッパは異教のままだったかもしれない - 神の計画！"
      }
    },

    74: {
      name: "リディア、最初のヨーロッパ人改宗者",
      challenge: "主がリディアの心を開いて、耳を傾けるようにされた...",
      easy: {
        question: "リディアの職業は何でしたか？",
        options: [
          "パン屋",
          "紫布の商人",
          "織物職人",
          "陶工"
        ],
        hint: "当時の高級品取引",
        funFact: "🟣 紫 = 非常に高価な王族の色 - リディアは裕福だった！"
      },
      medium: {
        question: "パウロはどこでリディアに会いましたか？",
        options: [
          "市場で",
          "祈りの場である川のほとりで",
          "彼女の家で",
          "会堂で"
        ],
        hint: "屋外の祈りの場",
        funFact: "🏞️ ピリピには会堂がなかった - 伝統に従って水のほとりで祈り！"
      },
      hard: {
        question: "リディアの改宗は神の働きについて何を明らかにしていますか？",
        options: [
          "彼女は素質があった",
          "神は御言葉を受ける準備ができた心を開く",
          "それは偶然だった",
          "パウロには説得力があった"
        ],
        hint: "回心における神の働きに関するもの",
        funFact: "💝 '主が彼女の心を開かれた' - 神は魂を準備し開く！"
      }
    },

    75: {
      name: "ピリピでの投獄",
      challenge: "真夜中ごろ、パウロとシラスは祈りつつ、神を賛美していた...",
      easy: {
        question: "なぜパウロとシラスは投獄されましたか？",
        options: [
          "窃盗",
          "悪霊を追い出して公共秩序を乱した",
          "冒涜",
          "暴動"
        ],
        hint: "占いの女奴隷の癒し",
        funFact: "💸 魂を解放することは搾取者に高くつく - 経済的迫害！"
      },
      medium: {
        question: "パウロとシラスは牢獄で何をしましたか？",
        options: [
          "不平を言った",
          "祈り、賛美した",
          "弁護の準備をした",
          "寝た"
        ],
        hint: "鎖にもかかわらず賛美",
        funFact: "🎵 真夜中の牢獄での賛美歌 - 印象的な揺るぎない信仰！"
      },
      hard: {
        question: "彼らの態度はどのように状況を変えましたか？",
        options: [
          "効果がなかった",
          "地震の後、看守が改宗した",
          "看守を苛立たせた",
          "彼らを狂わせた"
        ],
        hint: "模範による強力な証し",
        funFact: "🌍 地震 + 証し = 看守とその家族の改宗！"
      }
    },

    76: {
      name: "アテネで：アレオパゴス",
      challenge: "あなたがたが知らずに拝んでいるもの、それを私はあなたがたに宣べ伝えます...",
      easy: {
        question: "パウロはアテネでどの祭壇に言及しましたか？",
        options: [
          "ゼウス神に",
          "知られていない神に",
          "アポロに",
          "アテナに"
        ],
        hint: "出発点となった神秘的な碑文",
        funFact: "🏛️ '知られていない神に' - ギリシャ哲学との見事な接点！"
      },
      medium: {
        question: "パウロはアテネで誰の前で説教しましたか？",
        options: [
          "一般の群衆",
          "アレオパゴスのエピクロス派とストア派の哲学者",
          "神殿の祭司",
          "ローマ皇帝"
        ],
        hint: "ギリシャの知的エリート",
        funFact: "🧠 アレオパゴス = 古代のハーバード - 最高の思想家の前のパウロ！"
      },
      hard: {
        question: "アテネ人は復活にどのような反応を示しましたか？",
        options: [
          "全員一致の受け入れ",
          "分裂：嘲る者もいれば、興味を示す者もいた",
          "全般的な怒り",
          "完全な無関心"
        ],
        hint: "この神秘に対する知識人の典型的な反応",
        funFact: "🤔 復活 = 傲慢な人間の知性にとってのつまずきの石！"
      }
    },

    77: {
      name: "コリント：天幕作りのパウロ",
      challenge: "彼らのところに住み込んで、一緒に仕事をした。天幕作りが職業であったからである...",
      easy: {
        question: "パウロは生計を立てるためにどんな職業をしていましたか？",
        options: [
          "漁師",
          "天幕作り",
          "書記",
          "商人"
        ],
        hint: "彼が学んだ手仕事",
        funFact: "⛺ パウロ：使徒・職人 - クリスチャンの間での手仕事の尊厳！"
      },
      medium: {
        question: "パウロはコリントで誰の家に滞在しましたか？",
        options: [
          "宿屋",
          "アクラとプリスキラの家",
          "総督の家",
          "会堂"
        ],
        hint: "彼のような天幕作りの夫婦",
        funFact: "👫 アクラとプリスキラ：模範的な宣教師夫婦 - クリスチャンのもてなし！"
      },
      hard: {
        question: "なぜパウロは手で働いたのですか？",
        options: [
          "経済的必要性だけのため",
          "負担にならず、証しを確かにするため",
          "家族の伝統のため",
          "その職業が好きだったから"
        ],
        hint: "独立性と信頼性に関するもの",
        funFact: "💼 経済的自立 = 言論の自由 - パウロは誰にも依存していなかった！"
      }
    },

    78: {
      name: "エペソでの暴動",
      challenge: "大いなるかな、エペソ人のアルテミス！",
      easy: {
        question: "誰がエペソでパウロに対する暴動を引き起こしましたか？",
        options: [
          "ローマ当局",
          "銀細工人デメテリオと職人たち",
          "哲学者",
          "ユダヤの祭司"
        ],
        hint: "アルテミスの神殿を作っていた人々",
        funFact: "🏛️ 歴史上最初のストライキ：福音が偶像崇拝の経済を脅かす！"
      },
      medium: {
        question: "パウロはエペソでどのくらいの期間教えましたか？",
        options: [
          "6ヶ月",
          "1年",
          "2年",
          "3年"
        ],
        hint: "彼の最も長い宣教滞在",
        funFact: "📅 3年間の集中的な教え - エペソは重要な宣教拠点となった！"
      },
      hard: {
        question: "この暴動は福音の社会的影響について何を明らかにしていますか？",
        options: [
          "福音は何も変えない",
          "それは経済的・社会的構造を変革する",
          "宗教にのみ関係する",
          "争いを避ける"
        ],
        hint: "深い社会変革に関するもの",
        funFact: "💰 福音が進むと、偶像は市場を失う - 経済的影響！"
      }
    }
  }
};

export default chapter6Translations;
